import { render, staticRenderFns } from "./CreateWorkshop.vue?vue&type=template&id=7dcde1e4&scoped=true"
import script from "./CreateWorkshop.vue?vue&type=script&lang=js"
export * from "./CreateWorkshop.vue?vue&type=script&lang=js"
import style0 from "./CreateWorkshop.vue?vue&type=style&index=0&id=7dcde1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcde1e4",
  null
  
)

export default component.exports